<template>
  <van-field
    ref="field"
    v-model="score"
    :class="[focus || legal ? 'regular' : 'danger']"
    :error-message="focus || legal || score === '' ? '' : '分数需要在 60~120 之间'"
    :maxlength="maxlength"
    :placeholder="placeholder"
    type="tel"
    pattern="[0-9]*"
    :readonly="readonly"
    @focus="handleFocus"
    @blur="handleBlur"
    @input="handleInput"
    @keyup.enter="handleEnter"
    v-bind:disabled="this.userType==3"
    :style="{'background': this.userType == 3 ? '#C0C0C0' : ''}"
    clearable
  >
    <template v-if="!focus && score !== ''" slot="icon">
      <van-loading v-if="isLoading" type="spinner" size="20px"/>
      <van-icon v-else-if="legal" class="success" name="success"/>
      <van-icon v-else class="danger" name="info-o" @click="showTip"/>
    </template>
    <template slot="button">
      <slot name="button"></slot>
    </template>
  </van-field>
</template>

<script>
import Bus from '@/utils/eventBus'
import { handleToNumber } from '@/utils'
export default {
  name: 'FieldUnscore',
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    id: {
      type: [String, Number],
      required: true
    },
    userName: {
      type: String,
      required: true
    },
    userType: {
      type: Number,
      required: true
    },
    placeholder: {
      type: String
    },
    errorMessage: {
      type: String
    },
    maxlength: {
      type: [String, Number],
      default: 60
    },
    // 小数位
    digits: {
      type: Number,
      default: 0
    },
    // 最大数
    max: {
      type: Number,
      default: Math.pow(2, 53)
    },
    saved: {
      type: Boolean,
      default: false
    },
    focus: {
      type: Boolean,
      default: false
    },
    showResultStatus: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'change-score'
  },
  data() {
    return {
      score: this.value,
      oldScore: null,
      isLoading: false
    }
  },
  computed: {
    legal() {
      const score = parseFloat(this.score)
      return score >= 60 && score <= 120
    },
    readonly() {
      return this.saved ? this.isLoading : !this.focus && this.legal
    }
  },
  watch: {
    score(newValue) {
      this.$emit('change-score', newValue === '' ? '' : parseFloat(newValue))
    },
    focus(newValue) {
      newValue ? this.$refs['field'].focus() : this.$refs['field'].blur()
    }
  },
  methods: {
    handleFocus() {
      this.$emit('focus-field', this.id)
      this.oldScore = this.score
    },
    handleEnter() {
      this.$emit('focus-next-field', this.id)
    },
    handleBlur() {
      window.scrollTo(0, 0)
      if (this.score !== this.oldScore && this.legal) {
        this.isLoading = true
        const URL = this.saved
          ? `editscore?targetuid=${this.id}&score=${this.score}`
          : `scoring?targetuid=${this.id}&targetname=${this.userName}&score=${
              this.score
            }`
        this.$http
          .post(URL, null, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(() => {
            this.isLoading = false
            if (this.showResultStatus) {
              this.$toast({
                type: 'success',
                message: '评分成功！',
                duration: 1000
              })
            }
            setTimeout(() => {
              this.$emit('update:saved', true)
              Bus.$emit('change-scored-count', 1)
            }, 1000)
          })
          .catch(() => {
            this.isLoading = false
          })
      }
    },
    showTip() {
      this.$toast({ position: 'top', message: '分数只能在 60~120 之间' })
    },
    handleInput(value) {
      this.score = handleToNumber({ value })
    }
  }
}
</script>
